import { BillingBucketDTO } from "../DTO/billingBucketDTO";
import { BasicRequest } from "./basicRequest";

export class CreateBillingBucketRequest extends BasicRequest{
    public billingBucket!:BillingBucketDTO;
}